import React from "react";
import { motion } from "framer-motion";
import { Bike, FileCheck, CalendarCheck, Rocket } from "lucide-react";
import { STEPS } from "../../data/flyzone";
import { Button } from "../ui/button";
import { useBooking } from "./BookingProvider";

const ICONS = [Bike, FileCheck, CalendarCheck, Rocket];

export const HowItWorks = () => {
  const { openBooking } = useBooking();
  return (
    <section id="how" className="relative py-20 sm:py-28 bg-[#0A0A0A]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl mb-16">
          <span className="text-primary font-semibold text-sm uppercase tracking-widest">How It Works</span>
          <h2 className="mt-3 text-3xl sm:text-5xl font-display font-bold tracking-tight">
            Four steps to freedom
          </h2>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="hidden md:block absolute top-10 left-[12%] right-[12%] h-px bg-gradient-to-r from-primary/0 via-primary/40 to-primary/0" />
          {STEPS.map((s, i) => {
            const Icon = ICONS[i];
            return (
              <motion.div
                key={s.n}
                data-testid={`step-${i}`}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.45, delay: i * 0.12 }}
                className="relative text-center md:text-left"
              >
                <div className="relative z-10 grid place-items-center w-20 h-20 mx-auto md:mx-0 rounded-2xl bg-[#141414] border border-primary/30">
                  <Icon className="w-8 h-8 text-primary" />
                  <span className="absolute -top-3 -right-3 grid place-items-center w-8 h-8 rounded-full bg-primary text-black text-xs font-bold">
                    {s.n}
                  </span>
                </div>
                <h3 className="mt-6 text-xl font-display font-bold">{s.title}</h3>
                <p className="mt-2 text-sm text-white/60 leading-relaxed">{s.desc}</p>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-14">
          <Button
            data-testid="how-book-now"
            onClick={() => openBooking(null)}
            className="rounded-full bg-primary text-black hover:bg-primary/90 font-semibold px-8 py-6"
          >
            Start Your Booking
          </Button>
        </div>
      </div>
    </section>
  );
};
